import { render, staticRenderFns } from "./AcquiringPaymentInfo.vue?vue&type=template&id=efffc0e2&scoped=true&"
import script from "./AcquiringPaymentInfo.vue?vue&type=script&lang=js&"
export * from "./AcquiringPaymentInfo.vue?vue&type=script&lang=js&"
import style0 from "./AcquiringPaymentInfo.vue?vue&type=style&index=0&id=efffc0e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efffc0e2",
  null
  
)

export default component.exports